import { getters } from '@/modules/core/app/helpers/store';
import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import { RolePermissionKey } from '@/modules/ta/role/role.constants';

export class ServiceOverviewRouteConfig extends PageRouteConfig {
  /**
   * Any contextual permissions based on route
   * @returns {boolean}
   */
  canAccessRouteFromContext() {
    return (
      getters.session.getUserSettings().showServicesOverview &&
      (getters.session
        .getUserSettings()
        .hasPermission(Module.APP, RolePermissionKey.CAN_ACCESS_ACORN) ||
        getters.session
          .getUserSettings()
          .hasPermission(Module.APP, RolePermissionKey.CAN_ACCESS_RIPLEY) ||
        getters.session
          .getUserSettings()
          .hasPermission(Module.APP, RolePermissionKey.CAN_ACCESS_SHEETS) ||
        getters.session
          .getUserSettings()
          .hasPermission(Module.APP, RolePermissionKey.CAN_ACCESS_GDS))
    );
  }
}
